import { render, staticRenderFns } from "./ScoreThisPage.vue?vue&type=template&id=54a75bc8"
import script from "./ScoreThisPage.vue?vue&type=script&lang=js"
export * from "./ScoreThisPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports